/**
 * 左側抽屜頭部：拉取 member/info 顯示暱稱 / 帳號（與信用資料頁數據源一致）
 */
import { memberInfo } from '@/api/memberRestApi'
import { GAME_CODE_TO_LOTTERY } from '@/api/memberLotteryIds'
import { pickMemberDrawerLabels } from '@/utils/memberCreditProfile'
import { useMemberRestEnv } from '@/api/memberGameMobi'

const LS_USER = 'mobi_login_name'

export default {
  data() {
    return {
      memberProfileRaw: null,
    }
  },
  computed: {
    /** 本地登錄名 / 路由帶入，作為接口失敗時的後備 */
    drawerFallbackAccount() {
      const q = (this.$route && this.$route.query && this.$route.query.user) || ''
      const s = String(q).trim()
      if (s) return s
      try {
        return localStorage.getItem(LS_USER) || ''
      } catch (e) {
        return ''
      }
    },
    drawerTitlePrimary() {
      const { primary } = pickMemberDrawerLabels(this.memberProfileRaw, this.drawerFallbackAccount)
      return primary || '访客'
    },
    drawerTitleSecondary() {
      const { secondary } = pickMemberDrawerLabels(this.memberProfileRaw, this.drawerFallbackAccount)
      return secondary || ''
    },
  },
  mounted() {
    this.refreshDrawerMemberProfile()
  },
  methods: {
    async refreshDrawerMemberProfile() {
      if (!useMemberRestEnv()) return
      try {
        const lottery = GAME_CODE_TO_LOTTERY.ssc
        const raw = await memberInfo({ lottery })
        this.memberProfileRaw = raw
      } catch (e) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[mobi drawer] member/info', e)
        }
      }
    },
  },
}
